"use client";

import { ArrowRight, Building2, Check, MapPin, Truck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Servicesgrid() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const services = [];
  return;
}